
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import type { Application, CorporateStructure } from '@/types/database.types';

interface CorporateStructureInfoProps {
  register: UseFormRegister<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  watch?: UseFormWatch<Partial<Application>>;
  data?: Partial<Application>;
}

// Updated enum values to match the database enum
const CORPORATE_STRUCTURES = [
  { value: 'Sole Proprietorship', label: 'Sole Proprietorship' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'C-Corporation', label: 'C Corporation' },
  { value: 'S-Corporation', label: 'S Corporation' }, 
  { value: 'LLC', label: 'Limited Liability Company (LLC)' },
  { value: 'Non-Profit', label: 'Non-Profit' },
];

export const CorporateStructureInfo = ({ 
  register, 
  setValue, 
  watch,
  data
}: CorporateStructureInfoProps) => {
  const isNonProfit = watch ? watch('is_non_profit') : data?.is_non_profit;

  const handleStructureChange = (value: string) => {
    console.log("Corporate structure selected:", value);
    if (value === "select_structure") {
      // If selecting placeholder option, set to null
      setValue('corporate_structure', null);
      return;
    }
    
    // Validate that the value is one of our valid corporate structures
    const validValue = CORPORATE_STRUCTURES.find(s => s.value === value);
    if (validValue) {
      setValue('corporate_structure', value as CorporateStructure);
      console.log("Set corporate_structure to:", value);
    } else {
      // If invalid value, set to null
      setValue('corporate_structure', null);
      console.log("Invalid corporate_structure value, set to null");
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="corporate_structure" className="block text-gray-700 mb-1">Corporate Structure</Label>
        <Select 
          onValueChange={handleStructureChange}
          defaultValue={data?.corporate_structure || "select_structure"} 
        >
          <SelectTrigger>
            <SelectValue placeholder="Select your corporate structure" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="select_structure">Select...</SelectItem>
            {CORPORATE_STRUCTURES.map((structure) => (
              <SelectItem key={structure.value} value={structure.value}>{structure.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox 
          id="is_non_profit" 
          checked={!!isNonProfit}
          onCheckedChange={(checked) => {
            setValue('is_non_profit', !!checked);
          }}
        />
        <Label htmlFor="is_non_profit" className="cursor-pointer">
          My organization is a non-profit
        </Label>
      </div>
    </div>
  );
};
